import { ActionStatus } from '../../../Constants';
import { haveIAlreadyGone } from '../../Game/GamePlayerInfo';
import { available_docks_for_guest, CARD_NAMES, get_points_for_card } from '../../TwoD/Common/CardUtilities';

export default function artificialReceiveSpecial(gamePlayerController, aiPackage) {
    const gamePlayerData = gamePlayerController.gamePlayerData;
    // const tradelane = gamePlayerData.special_card_orbit;
    const cardId = gamePlayerData.special_card;

    const docks = available_docks_for_guest(gamePlayerData.docks, cardId);

    if (docks.length === 0) {
        // All docks are full: there is no legal dock for this Special Guest.
        // The engine's special_dock_choice (advertisement_action.py:730) reads
        // a Special click with NO dock key as the Manual 7.2.5 DEFEND path (the
        // card leaves the river to defense/discard). Emit that explicit decline
        // rather than indexing docks[-1] into an undefined dock and emitting
        // placeSpecialGuest(undefined) as a bogus placement.
        const declineName = CARD_NAMES[cardId];
        aiPackage.success = true;
        aiPackage.addProvenance(
            `Is there an open Dock for ${declineName}?`,
            false,
            'All Docks are full; defend the Special Guest.');
        aiPackage.addToMessage(`No open Dock for ${declineName}; defend.`);
        if (aiPackage.execute) {
            gamePlayerController.gamePlayerApi.placeSpecialGuest();
        }
        return;
    }

    const iHaveNotGoneYet = !haveIAlreadyGone(
        gamePlayerController.gameData, gamePlayerData);
    let question = `Have I gone yet?`;
    let answer = !iHaveNotGoneYet;
    let reason = `If I have not gone, I can get Lodging still.`;
    aiPackage.addProvenance(question, answer, reason);

    let dockPoints = [];
    docks.forEach(dockIndex => {
        let pointData = get_points_for_card(
            gamePlayerData.station,
            gamePlayerData.robot_assignments,
            gamePlayerData.lodging,
            cardId, dockIndex,
            true,
            iHaveNotGoneYet);  // which means I can still use the card.
        let points = -1;
        if (pointData.points !== 'Danger') points = pointData.points;
        dockPoints.push(points);
    })
    const max = Math.min(...dockPoints);
    const dock = docks[dockPoints.indexOf(max)];
    const name = CARD_NAMES[cardId];

    question = `Which Dock is best for ${name}? `;
    answer = dock;
    reason = `Best chance to possibly make ${max} points.`;
    aiPackage.addProvenance(question, answer, reason);

    const attacker = gamePlayerController.gameData.gameplayer_set.find(gamePlayer => gamePlayer.action_status===ActionStatus.ATTACKING_ID);
    // The attacker may have already left ATTACKING_ID by the time this reactive
    // handler fires (a race); attacker is then undefined. It is used only for
    // the narration string, so fall back to a label rather than letting
    // attacker.name throw before the placeSpecialGuest emit (which parked the
    // seat).
    const attackerName = attacker ? attacker.name : 'another player';

    aiPackage.success = true;
    aiPackage.addToMessage(`Place ${name} from ${attackerName} in Dock ${dock}`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.placeSpecialGuest(dock);
    }
}
